import {
    loadingEffect,
    parseDataAttribute,
    generateLibraryUrl,
    LibraryLoader
} from './library'
import {initPlayer, getDefaultConfig} from "./video-player";

jQuery(function ($) {
    const slider = $('#video-player-overlay-slider')
    const videoLibraryModal = '#video-library-modal'
    const closeSearchModal = $('#closeSearchModal')
    const hamburger = $('#hamburger')
    const headline = $('.video-player-overlay__headline')
    const classActiveVideo = 'active-video'
    const regularCardTitle = '.regular-card__title'
    let activeVideoId = null
    let videoPlayerOverlay = null
    let isPlayerBroken = false
    const netflixLoading = slider.siblings('.netflix-loading');

    netflixLoading.hide();

    slider.not('.slick-initialized').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        accessibility: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slide: ''
                }
            },
            {
                breakpoint: 525,
                settings: {
                    slidesToShow: 1,
                }
            }
        ],
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><img src="/assets/img/icons/icon_light_arrowleft.svg" alt="Previous"/></button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button"><img src="/assets/img/icons/icon_light_arrowright.svg" alt="Next"/></button>',
    })

    slider.on('reInit', function() {
        slider.slick('refresh')
    })

    slider.on('click','.slick-next', function(){
            nextClick(slider)
    });

    slider.on('swipe', function(event, slick, direction) {
           if(direction === 'left'){
               nextClick(slider)
           }
    });

    $(document).on('click', "[data-type='gameLibrary'] .item a", function(event) {
        event.preventDefault();
        const sliderUniqueId = $(this).attr('data-sliderUniqueId');
        const elementsFromSelectedSlider = $(`[data-sliderUniqueId=${sliderUniqueId}]`);
        $.each(elementsFromSelectedSlider, function(i, item) {
            const {tag, headline, date, videoid, imgurl} = $(item).data()
            const img = (imgurl) ? imgurl.slice(5,-2) : '';
            const elementSlider = createElement(tag, headline, date,videoid, img);
            slider.slick('slickAdd', elementSlider);
        })
    })


    function createElement(tag, headline,date, videoid, img){
        return `<div><div>
                    <a class="regular-card" href="javascript:void(0)" data-id="${videoid}" >
                        <div class="regular-card__header">
                            <img class="regular-card__img" src="${img}" alt="article">
                            <img class="regular-card__icon" src="/assets/img/icons/icon_dark_video@3x.svg" alt="video">
                        </div>
                        <div class="regular-card__content">
                            <div class="regular-card__title">
                            ${headline}
                            </div>
                            <div class="regular-card__date">
                            ${date}
                            </div>
                        </div>
                    </a>
                    </div></div>
                `
    }

    function onError () {
        isPlayerBroken = true
    }

    function nextClick(slider) {
        const currentActiveSlide = slider.slick('slickCurrentSlide');
        const slidesToShow = parseInt(slider.slick('slickGetOption', 'slidesToShow'),10);
        const visibleIndex = currentActiveSlide + slidesToShow + 2;
        const currentOffset = parseInt(slider.attr('data-offset'),10);
        const totalSlides = parseInt(slider.attr('data-totalslides'),10);
        let loadedSlides = parseInt(slider.attr('data-loadedslides'),10);
        const loader = slider.data('loader') || slider.data('loader', (() => {
            const loader = new LibraryLoader();
            loader.tags = parseDataAttribute(slider.attr('data-tags'));
            loader.query = $(videoLibraryModal).data('selectedFilterTags');
            loader.type = parseDataAttribute(slider.attr('data-types'));
            loader.sort('date_desc');
            return loader;
        })()).data('loader');


        if(visibleIndex >= loadedSlides && loadedSlides < totalSlides) {
            loadingEffect(slider, true);
            loader.load(currentOffset).then(result => {
                loadedSlides += result.data.length;
                slider.attr('data-offset', loadedSlides + 1);
                slider.attr('data-loadedslides', loadedSlides);
                $.each(result.data, (i, item) => {
                    if (!item) {
                        return;
                    }

                    const queryArray = item.url.split('/')
                    const videoId = queryArray[queryArray.length - 1]
                    const element = createElement(item.tag,item.headline, item.date,videoId, item.image['348x164'])
                    slider.slick('slickAdd', element);
                });
                loadingEffect(slider, false);
            });
        }
    }

    $(videoLibraryModal).on('show.bs.modal', () => {
        closeSearchModal.css('display', 'block')
        hamburger.css('display', 'none')

        const closeOverlayVideoContentBtn = $('.icon-close-overlay-video')

        closeOverlayVideoContentBtn.on('click', function() {
            videoPlayerOverlay.remove()
            closeSearchModal.css('display', 'none')
            hamburger.css('display', 'none')
        })

        const videoId = $(videoLibraryModal).data('initialId')
        videoPlayerOverlay = createPlayer(videoId)

        if (videoPlayerOverlay) {
            closeSearchModal.on('click', () => {
                videoPlayerOverlay.remove()
                $(videoLibraryModal).modal('hide')
            })

            videoPlayerOverlay.on('error', onError)
            videoPlayerOverlay.on('loaded', onLoaded)
            videoPlayerOverlay.on('ended', onEnded)
        }
    })

    slider.on('click', '.regular-card', function() {
        $('.video-player-overlay-slider .regular-card').removeClass(classActiveVideo)

        const videoId = $(this).data('id')
        const currentTitle = $(this).find(regularCardTitle).first().text()

        headline.first().text(currentTitle)

        $(this).addClass(classActiveVideo)

        const slideNumber = $(this).closest('.slick-slide').attr('data-slick-index')
        slider.slick('slickGoTo', slideNumber)
        nextClick(slider);

        if (isPlayerBroken) {
            videoPlayerOverlay.remove()

            videoPlayerOverlay = createPlayer(videoId)

            resubscribe(videoPlayerOverlay)
            return
        }

        if (videoPlayerOverlay) {
            reloadPlayer(videoPlayerOverlay, videoId)
            resubscribe(videoPlayerOverlay)
        }
    })

    $('.icon-close-overlay-video').on('click', function(){
        slider.slick('removeSlide', null, null, true);
    });

    function onLoaded () {
        const videos = $('[data-id]')
        videos.removeClass(classActiveVideo)

        activeVideoId = videoPlayerOverlay.getConfig().videoid
        const activeVideo = $(`.video-player-overlay-slider a[data-id=${activeVideoId}]`)
        activeVideo.addClass(classActiveVideo)

        const indexActiveVideo = $(videos).index(activeVideo)
        slider.slick('slickGoTo',`${indexActiveVideo - 1}`)
    }

    function onEnded () {
        const videos = $('[data-id]')
        let currentSlide = slider.slick('slickCurrentSlide');
        const slidesToShow = parseInt(slider.slick('slickGetOption', 'slidesToShow'),10);
        const visibleIndex = currentSlide + slidesToShow + 1;
        if(visibleIndex >= videos.length){
           $('a.regular-card').each(function(){
                if($(this).hasClass('active-video')){
                    currentSlide = parseInt($(this).closest('.slick-slide').attr('data-slick-index'),10);
                }
           });
        }
        const nextSlide = videos[currentSlide + 2]
        if (!nextSlide) {
            return
        }
        const idNextVideo = $(nextSlide).data('id')
        const headlineNextVideo = $(nextSlide).find(regularCardTitle).text()

        nextClick(slider);
        headline.text(headlineNextVideo)

        reloadPlayer(videoPlayerOverlay, idNextVideo)

        videoPlayerOverlay.resubscribe('error', onError)
        videoPlayerOverlay.resubscribe('loaded', onLoaded)
        videoPlayerOverlay.resubscribe('ended', onEnded)
    }

    function resubscribe(player) {
        player.resubscribe('error', onError)
        player.resubscribe('loaded', onLoaded)
        player.resubscribe('ended', onEnded)
    }
})

function reloadPlayer(player, videoId) {
    try {
        player.reloadPlayer(getDefaultConfig('video-player-overlay', videoId));
    } catch (error) {}
}

function createPlayer(videoId) {
    $('#video-player-overlay').attr('data-id', `${videoId}`)

    const spinner = $('#video-player-spinner')

    spinner.show()

    const newPlayer =  initPlayer('video-player-overlay', videoId);
    newPlayer.on('loaded', () => spinner.hide())

    return newPlayer
}
